import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { DialogContentText } from '@material-ui/core';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Grid, TextField, FormLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import MobileDetect from 'mobile-detect';
import { Document, Page, pdfjs } from 'react-pdf';
import Button from '../../../components/Button';
import NoticeDialog from '../../../components/DialogModals/NoticeDialog';
import ProviderSearchBar from '../../../components/ProviderSearchBar';
import VisitInformation from '../../../components/VisitInformation';
import PDFSingleViewer from '../../../components/PDFSingleViewer';
import ImgSingleViewer from '../../../components/ImgSingleViewer';
import { fileSelectHandler } from '../../../util/fileHandling';
import * as authApi from '../../../services/api/auth';
import { fetchProvider, createConsultNote } from '../../../services/api';
import { createAppointmentRequest } from '../../../services/api/admin';
import { validate } from 'email-validator';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
  pdfjs.version
}/pdf.worker.js`;

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};
function BookAppointmentCheckout(props) {
  const {
    provider,
    tenancy,
    referringProvider,
    patient,
    bookAppointment,
    appointment,
    onNotesFieldChange,
    setPropImages,
    imagesProps,
    onReferringProviderSelected,
    classes,
    overBookAlert, 
    closeAlert,    
    // openDuplicateApptAlert,
    // closeDuplicateApptAlert,
    classes: {
      root,
      visitInfo,
      confirmationFields,
      confirmationCardAppointmentSection,
      confirmationCardAppointmentSectionTitle,
      confirmationCardAppointmentSectionText,
      notes,
      previewImg,
      customFileUpload,      
      button,
      btnCenter
    },
  } = props;

  const { fullTitle: providerName } = provider;
  const { name: patientName } = patient;
  const { location } = tenancy;
  const { startTimestamp } = appointment;
  const appointmentStart = moment(startTimestamp);

  const [currentUser, setCurrentUser] = useState({});
  const [fromProviderId, setFromProviderId] = useState('');
  const [images, setImages] = useState([]);
  const [popNotice, setPopNotice] = useState('');
  const [openImgModal, setOpenImgModal] = useState(false);
  const [currentImg, setCurrentImg] = useState('');
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [currentPDF, setCurrentPDF] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [imagePreview, setImagePreview] = React.useState(true);
  const md = new MobileDetect(window.navigator.userAgent);
  const isMobile = md.mobile();
  const myRefOne = useRef(null);
  const myRefTwo = useRef(null);

  useEffect(() => {
    (async () => {
      const fetchedCurrentUser = await authApi.fetchCurrentUser();
      setCurrentUser(fetchedCurrentUser);
      if (fetchedCurrentUser.provider.id) {
        setFromProviderId(fetchedCurrentUser.provider.id);
      }
    })();
  }, []);

  const createRequestNote = async () => {
    const noteParams = {
      fromProviderId,
      toProviderId: provider.id,
      body: props.appointment.portalNotes || '',
      patientId: patient.id,
      requestingAppt: true,
      attachments: images.map(i => i.dataUrl),
    };
    //await createAppointmentRequest(noteParams)
    await createConsultNote(noteParams);
    bookAppointment(false); // false surpresses the call to book an appointment
  };

  const inputPicCallBack = fileObject => {
    setImages(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRefTwo.current.value = null;
        setImages([]);
      }
    });
  };

  const inputPicCallBackProps = fileObject => {
    setPropImages(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRefOne.current.value = null;
        setPropImages([]);
      }
    });
  };

  // const inputPicCallBackProps = fileObject => {
  //   const [fileObjectOrStatusCode] = fileObject;
  //   if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
  //     const notice = (fileObjectOrStatusCode === -1) ? 'Max file size is 5MB' : 'Please use a file of type .jpg, .jpeg, or .pdf';
  //     setPopNotice(notice);
  //   } else {
  //     setPropImages([
  //       ...images,
  //       fileObjectOrStatusCode,
  //     ])
  //   }
  // }

  const handleOpenImg = link => {
    setOpenImgModal(true);
    setCurrentImg(link);
  };

  const handleOpenPDF = link => {
    setOpenPDFModal(true);
    setCurrentPDF(link);
  };

  const validate = () => {
    const nextErrors = {};
    let valid = true;
    if (!appointment.portalNotes) {
      nextErrors.body = 'Requests require a note';
      valid = false;
    }
    setValidationErrors(nextErrors);
    return valid;
  };

  return (
    <Grid container spacing={8} className={root}>
      <Grid item xs={12} sm={4} className={visitInfo}>
        <VisitInformation
          provider={provider}
          tenancy={tenancy}
          appointmentTime={appointmentStart}
        />
      </Grid>

      {referringProvider ? (
        <Grid item xs={12} sm={6}>
          <div className={confirmationFields}>
            <div className={confirmationCardAppointmentSection}>
              <h4 className={confirmationCardAppointmentSectionTitle}>
                Patient
              </h4>
              <span className={confirmationCardAppointmentSectionText}>
                {patientName}
              </span>
            </div>

            <div className={confirmationCardAppointmentSection}>
              <h4 className={confirmationCardAppointmentSectionTitle}>
                Provider
              </h4>
              <span className={confirmationCardAppointmentSectionText}>
                {providerName}
              </span>
            </div>

            {currentUser.administrator && currentUser.administrator.id && (
              <div className={confirmationCardAppointmentSection}>
                <h4 className={confirmationCardAppointmentSectionTitle}>
                  On behalf of
                </h4>
                <ProviderSearchBar
                  clearable={false}
                  label=""
                  practiceId={currentUser.administrator.practiceId}
                  onSelect={async selectedProvider => {
                    if (selectedProvider) {
                      setFromProviderId(selectedProvider.id);
                    }
                  }}
                />
              </div>
            )}

            <div className={confirmationCardAppointmentSection}>
              <h4 className={confirmationCardAppointmentSectionTitle}>Notes</h4>
              <TextField
                multiline
                variant="outlined"
                name="portalNotes"
                helperText="These will not be visible to the patient."
                rows="4"
                value={appointment.portalNotes}
                error={validationErrors.body}
                // helperText={validationErrors.body}
                onChange={e => {
                  onNotesFieldChange(e);
                  setValidationErrors({
                    ...setValidationErrors,
                    body: false,
                  });
                }}
                className={notes}
              />
            </div>
            <FormLabel component="legend">Add attachments</FormLabel>
            <input
              className={classes.attachmentsBtn}
              ref={myRefTwo}
              type="file"
              multiple
              onChange={event =>
                fileSelectHandler(
                  event.target.files,
                  inputPicCallBack,
                  ['jpg', 'jpeg', 'pdf'],
                  1048576 // 1048576 bytes = 1MB
                )
              }
            />
            {images.length > 0 && isMobile ? (
              <div>{images.length} images attached</div>
            ) : (
              images.map((image, index) =>
                image.fileType === 'pdf' ? (
                  <>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => handleOpenPDF(image.dataUrl)}
                    >
                      Click to Preview
                    </Button>
                    <a
                      className="custom-popup-download-btn"
                      target="_blank"
                      href={image && image.dataUrl}
                      download
                    >
                      Download
                    </a>

                    {/* <Document file={image.dataUrl} options={options} className={previewImg}>
                      <Page pageNumber={1} />
                    </Document> */}

                    <PDFSingleViewer
                      openPDFModal={openPDFModal}
                      currentPDF={currentPDF}
                      onClose={() => setOpenPDFModal(false)}
                    />
                  </>
                ) : (
                  <Grid container item xs={12} style={{ padding: '0px' }}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: '0px',
                      }}
                    >
                      <Button
                        // disabled={!imagePreview}
                        className="appointment-preview-btn"
                        disabled={
                          image?.fileType === 'htm' ||
                          image?.fileType === 'html'
                        }
                        color="primary"
                        variant="contained"
                        onClick={() => handleOpenImg(image.dataUrl)}
                      >
                        Click to Preview
                      </Button>
                      <a
                        className="custom-popup-download-btn"
                        target="_blank"
                        href={image && image.dataUrl}
                        download
                        style={{ textAlign: 'center' }}
                      >
                        Download
                      </a>
                    </Grid>

                    {/* <img src={ image && image.dataUrl} key={`picture-${index}`} onError={()=>setImagePreview(false)} alt="To see full report, please download the file" className={previewImg} />                       */}
                    <ImgSingleViewer
                      openImgModal={openImgModal}
                      currentImg={currentImg}
                      onClose={() => setOpenImgModal(false)}
                    />
                  </Grid>
                )
              )
            )}
            <Button
              color="primary"
              variant="contained"
              onClick={createRequestNote}
              disabledDuringOnClick={true}
              onClickValidation={validate}
              onClickSuccessSnackbar="Appointment requested!"
              onClickFailSnackbar="Unable to request appointment. Please try again."
            >
              Request Appointment
            </Button>
          </div>
        </Grid>
      ) : (
        <Grid item xs={12} sm={6}>
          <div className={confirmationFields}>
            <div className={confirmationCardAppointmentSection}>
              <h4 className={confirmationCardAppointmentSectionTitle}>
                Patient
              </h4>
              <span className={confirmationCardAppointmentSectionText}>
                {patientName}
              </span>
            </div>

            <div className={confirmationCardAppointmentSection}>
              <h4 className={confirmationCardAppointmentSectionTitle}>
                Provider
              </h4>
              <span className={confirmationCardAppointmentSectionText}>
                {providerName}
              </span>
            </div>

            <div className={confirmationCardAppointmentSection}>
              <h4 className={confirmationCardAppointmentSectionTitle}>
                Location
              </h4>
              <span className={confirmationCardAppointmentSectionText}>
                {location}
              </span>
            </div>

            <div className={confirmationCardAppointmentSection}>
              <h4 className={confirmationCardAppointmentSectionTitle}>
                Date & Time
              </h4>
              <span className={confirmationCardAppointmentSectionText}>
                {appointmentStart.format('ddd, MMM Do - h:mm a z')}
              </span>
            </div>

            {currentUser.administrator && currentUser.administrator.id && (
              <div className={confirmationCardAppointmentSection}>
                <h4 className={confirmationCardAppointmentSectionTitle}>
                  On behalf of
                </h4>
                <ProviderSearchBar
                  clearable={false}
                  label=""
                  practiceId={currentUser.administrator.practiceId}
                  onSelect={async selectedProvider => {
                    if (selectedProvider) {
                      const { userId } = await fetchProvider(
                        selectedProvider.id
                      );
                      onReferringProviderSelected(userId);
                    }
                  }}
                />
              </div>
            )}

            <div className={confirmationCardAppointmentSection}>
              <h4 className={confirmationCardAppointmentSectionTitle}>Notes</h4>
              <TextField
                multiline
                variant="outlined"
                name="portalNotes"
                helperText="Patients will not see any notes."
                rows="4"
                value={appointment.portalNotes}
                error={validationErrors.body}
                // helperText={validationErrors.body}
                onChange={e => {
                  onNotesFieldChange(e);
                  setValidationErrors({
                    ...setValidationErrors,
                    body: false,
                  });
                }}
                className={notes}
              />
            </div>

            <Dialog
              open={overBookAlert}
              onClose={closeAlert}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                An appointment has already been booked for this slot. Please choose some other available slot.
                </DialogContentText>
                <div className={btnCenter}>
                <Button
                  onClick={closeAlert}
                  variant="contained"
                  color="primary"
                  className={button}
                >
                  Ok
                </Button>
                </div>
                
              </DialogContent>
            </Dialog>

{/* Restrict dupliacte appointments for the same day */}
{/*
<Dialog
          open={openDuplicateApptAlert}
          onClose={closeDuplicateApptAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            An appointment has already been booked for this patient on the selected date. Please return to the schedule and select another day to book an appointment.
            </DialogContentText>
            <div className={btnCenter}>
              <Button
                onClick={closeDuplicateApptAlert}
                variant="contained"
                color="primary"
                className={button}
              >
                Ok
              </Button>
            </div>
          </DialogContent>
        </Dialog>
        */}

            <FormLabel component="legend">Add attachments</FormLabel>
            <input
              className={classes.attachmentsBtn}
              ref={myRefOne}
              type="file"
              multiple
              onChange={event =>
                fileSelectHandler(
                  event.target.files,
                  inputPicCallBackProps,
                  ['jpg', 'jpeg', 'pdf'],
                  1048576 // 1048576 bytes = 1MB
                )
              }
            />
            {imagesProps.length > 0 && isMobile ? (
              <div>{imagesProps.length} images attached</div>
            ) : (
              imagesProps.map((image, index) =>
                image.fileType === 'pdf' ? (
                  <>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => handleOpenPDF(image.dataUrl)}
                    >
                      Click to Preview
                    </Button>
                    <a
                      className="custom-popup-download-btn"
                      target="_blank"
                      href={image && image.dataUrl}
                      download
                    >
                      Download
                    </a>

                    {/* <Document file={image.dataUrl} options={options} className={previewImg}>
                      <Page pageNumber={1} />
                    </Document> */}

                    <PDFSingleViewer
                      openPDFModal={openPDFModal}
                      currentPDF={currentPDF}
                      onClose={() => setOpenPDFModal(false)}
                    />
                  </>
                ) : (
                  <Grid container item xs={12}>
                    <Grid item xs={12}>
                      <Button
                        // disabled={!imagePreview}
                        disabled={
                          image?.fileType === 'htm' ||
                          image?.fileType === 'html'
                        }
                        color="primary"
                        variant="contained"
                        onClick={() => handleOpenImg(image.dataUrl)}
                      >
                        Click to Preview
                      </Button>
                      <a
                        className="custom-popup-download-btn"
                        target="_blank"
                        href={image && image.dataUrl}
                        download
                      >
                        Download
                      </a>
                    </Grid>

                    {/* <img src={ image && image.dataUrl} key={`picture-${index}`} onError={()=>setImagePreview(false)} alt="To see full report, please download the file" className={previewImg} /> */}
                    <ImgSingleViewer
                      openImgModal={openImgModal}
                      currentImg={currentImg}
                      onClose={() => setOpenImgModal(false)}
                    />
                  </Grid>
                )
              )
            )}

            <Button
              color="primary"
              variant="contained"
              onClick={bookAppointment}
              disabledDuringOnClick={true}
              onClickValidation={validate}
            >
              Book Appointment
            </Button>
          </div>
        </Grid>
      )}
      {popNotice && (
        <NoticeDialog
          open={popNotice}
          onOkClick={() => setPopNotice('')}
          noticeTitle="Notice"
          message={popNotice}
        />
      )}
    </Grid>
  );
}
BookAppointmentCheckout.propTypes = {
  patient: PropTypes.object.isRequired,
  provider: PropTypes.object.isRequired,
  appointment: PropTypes.object.isRequired,
  tenancy: PropTypes.object.isRequired,
  referringProvider: PropTypes.object,
  bookAppointment: PropTypes.func.isRequired,
};
const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px',
    width: '100%',
    height: '100%',
  },
  customFileUpload: {
    display: 'inline-block',
    backgroundColor: '#505d68',
    color: 'white',
    padding: '0.5rem 1rem',
    borderRadius: '0.3rem',
    cursor: 'pointer',
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  visitInfo: {
    marginRight: '25px',
    '@media only screen and (max-width: 1024px)': {
      marginRight: '0',
      marginBottom: '25px',
    },
  },
  confirmationCard: {
    backgroundColor: '#EBF5FF',
    padding: '30px',
    border: '1px solid #D9D9D9',
    borderRadius: '4px',
    margin: '0 20px',
  },
  confirmationFields: {
    margin: '0 20px',
  },
  confirmationCardAppointment: {
    marginTop: '24px',
  },
  confirmationCardAppointmentSection: {
    paddingBottom: '34px',
  },
  confirmationCardAppointmentSectionTitle: {
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'normal',
  },
  confirmationCardAppointmentSectionText: {
    color: '#1C2B39',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '19px',
  },
  notes: {
    width: '100%',
  },
  attachmentsBtn: {
    paddingBottom: '5px',
  },
  button: {
    width: '100px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '0px',
    marginBottom: '15px',
  },
  btnCenter: {
    display: 'flex',
    alignItems: 'center'

  }
});
export default withStyles(styles)(BookAppointmentCheckout);
